import { StringsType } from "./en"

export const de: StringsType = {
  bubbleExpiration: {
    expiredTitle: "Kostenloses Premium ist abgelaufen",
    expiredSubtitle: "Upgrade auf Premium für das beste PhotoVault-Erlebnis",
    expiredSubtitlePremium:
      "Upgrade auf Premium für ein großartiges PhotoVault-Erlebnis",
    expiredSubtitleUltimate:
      "Upgrade auf Ultimate für das beste PhotoVault-Erlebnis",
    trashRecovery: "Papierkorb-Wiederherstellung",
    cloudVault: "Cloud Vault",
    spaceSaver: "Space Saver",
    noAds: "Keine Werbung",
    everyPremiumFeature: "Erhalte alle\nPremium-Funktionen",
    everyUltimateFeature: "Erhalte alle\n Ultimate-Funktionen",
    unlockUltimateTools: "Schalte alle Datenschutz-Tools in der App frei.",
    cloudVaultUltimate: "Cloud Vault - 1.000 GB",
    organizationPlus: "Organisation+",
    organizationPlusDesc: "Unter-Alben erstellen, Duplikate finden und mehr.",
    perMonth: "pro Monat",
    perYear: "pro Jahr",
    justOnce: "nur einmal",
    lifetime: "Lebenslang",
    threeMonths: "3 Monate",
    lifetimeTitle: "Lebenslanger Plan",
    lifetimeDescription:
      "Der lebenslange Plan wird bald verfügbar sein. Bleiben Sie dran für Updates!",
    lifetimeFeature1: "Einmalzahlung",
    lifetimeFeature2: "Lebenslanger Zugang zu allen Funktionen",
    lifetimeFeature3: "Bester Wert für Langzeitnutzer",
    lifetimeCta: "Lifetime kaufen",
    lifetimeSheetDisclaimer: "Cloud-Backup (50GB) ist für 5 Jahre enthalten.",
    lifetimeSheetDisclaimerDetailed:
      "5 Jahre Cloud Vault Backup (50 GB) sind in Ihrem Lifetime-Plan enthalten. Danach sind Sie berechtigt für ein vergünstigtes Cloud Vault Abonnement, das nur für Lifetime-Mitglieder verfügbar ist. Alle Premium-Funktionen bleiben immer ohne zusätzliche Kosten verfügbar.",
    lifetimeDisclaimerCloudStorage:
      "5 Jahre Cloud Vault Backup (50 GB) sind in Ihrem Lifetime-Plan enthalten.",
    lifetimeDisclaimerAfterPeriod:
      "Nach 5 Jahren sind Sie berechtigt für ein vergünstigtes Cloud Vault Abonnement, das nur für Lifetime-Mitglieder verfügbar ist.",
    lifetimeDisclaimerPremiumFeatures:
      "Alle Premium-Funktionen bleiben immer ohne zusätzliche Kosten verfügbar.",
    monthly: "Monatlich",
    yearly: "Jährlich",
    selectPlan: "Wählen Sie einen Plan zum Fortfahren",
    unlockPrivacyTools: "Schalten Sie exzellente Datenschutz-Tools frei.",
    cloudVaultGB: "Cloud Vault - 50 GB",
    secureBackups: "Sichere Backups, die verschlüsselt bleiben.",
    freeUpSpace: "Schaffen Sie Platz auf Ihrem Telefon.",
    recoverDeleted: "Wiederherstellen gelöschter Elemente aus dem Papierkorb.",
    fullExperience: "Das volle Erlebnis ohne Unterbrechungen.",
    restorePurchases: "Käufe wiederherstellen",
    basicTitle: "Private Photo Vault Basic",
    free: "KOSTENLOS",
    basicDescription:
      "Basic ist die kostenlose Version von PhotoVault. Es schützt immer noch Ihre wichtigen Fotos hinter einem PIN-Bildschirm und bietet Ihnen gute Datenschutzfunktionen.",
    switchToBasic: "Zu Basic wechseln",
    termsOfService: "Nutzungsbedingungen",
    privacy: "Datenschutz",
    switchToPremium: "Wechsle zu Premium",
    switchToUltimate: "Wechsle zu Ultimate",
    premiumExpiredTitle: "Premium ist abgelaufen",
    ultimateExpiredTitle: "Ultimate ist abgelaufen",
    renewSubtitle: "Erneuern Sie für das beste Private Photo Vault Erlebnis",
    selectPlanOrSwitchToPro:
      "Wählen Sie einen Plan oder wechseln Sie kostenlos zu Pro",
    selectPlanOrSwitchToBasic:
      "Wählen Sie einen Plan oder wechseln Sie kostenlos zu Basic",
    proTitle: "Private Photo Vault - Pro",
    purchased: "Gekauft",
    proDescription:
      "Da Sie zuvor die einmalige Pro-Version gekauft haben, können Sie weiterhin alle Pro-Funktionen nutzen, für die Sie bezahlt haben.",
    switchToPro: "Zu Pro wechseln",
    subscribeFor: (price: string) => `Abonnieren für ${price}/Jahr`,
    subscribeForMonth: (price: string) => `Abonnieren für ${price}/Monat`,
    billedPerYear: (price: string) => `${price} pro Jahr abgerechnet`,
    oneStepSubtitle:
      "Upgrade auf Premium für das beste\nPrivate Photo Vault Erlebnis",
    oneStepSubtitleUltimate:
      "Upgrade auf Ultimate für das beste\nPrivate Photo Vault Erlebnis",
    purchaseWithAppStore: "Mit App Store kaufen",
  },
  title: "Unbegrenzter Zugang zu allen Funktionen",
  freeTrial: "Kostenlose Probeversion",
  startPlan: "Abo beginnen",
  pricePerMonth: (price: any) => `${price}/Mon.`,
  pricePerYear: (price: any) => `Abrechnung als ${price}/Jahr`,
  freeTrialDescriptionYearly: (days: number, price: string) =>
    `${days} Tage gratis, danach ${price}/Jahr. Jederzeit kündbar`,
  freeTrialDescriptionMonthly: (days: number, price: string) =>
    `${days} Tage gratis, danach ${price}/Mon. Jederzeit kündbar`,
  discount: (discount: number) => `${discount}% RABATT`,
  new: "Neu",
  trashRecovery: "Papierkorbwiederherstellung",
  adFree: "Werbefreies Erlebnis",
  breakIn: "Zugriffsbericht: Foto & GPS",
  wireless: "Drahtlose Bildubertragung",
  decoy: "Täuschungspasscode",
  pattern: "Sperrmuster",
  appDisguise: "App-Tarnung",
  comingSoon: "Kommt bald",
  subscriptionTerms: "Abonnementbedingungen:",
  terms:
    "Die Zahlung wird nach der Kaufbestätigung über dein iTunes-Konto verrechnet. Das Abonnement wird automatisch verlängert, sollte es nicht mindestens 24 Stunden vor dem Ende der aktuellen Laufzeit deaktiviert werden. Das Konto wird innerhalb von 24 Stunden vor dem Ende des aktuellen Zeitraums belastet. Du kannst dein Abonnement verwalten und die automatische Verlängerung deaktivieren, indem du nach dem Einkauf auf deine Kontoeinstellungen gehst.",
  privacy: "Datenschutz",
  alreadyPurchased: "Bereits gekauft?",
  termsButton: "Bedingungen",
  monthly: "MONATLICH",
  yearly: "JÄHRLICH",
  popular: "BELIEBT",
  save: (discount) => `SPAREN SIE ${discount}%`,
  anniversaryTitle: (discount) => `Jubiläumsangebot - SPAREN SIE ${discount}%`,
  blackFridayTitle: (discount) => `Black Friday - SPAREN SIE ${discount}%`,
  year: "Jahr",
  years: "Jahre",
  hour: "Stunde",
  hours: "Stunden",
  minute: "Minute",
  minutes: "Minuten",
  second: "Sekunde",
  seconds: "Sekunden",
  promoSubtitle: (hours) =>
    `Beeil dich, dieses Angebot dauert nur ${hours} Stunden`,
  offerExpires: "Bis das Angebot abläuft",
  unlockDeal: "Angebot freischalten",
  blackFridayPaywallTitle: "Black Friday-Angebot",
  anniversaryPaywallTitle: "Dein Jubiläumsangebot 🎉",
  blackFridayPaywallSubtitle:
    "Verpasse nicht dieses einmalige Angebot zum Black Friday! Erhalte riesige Ersparnisse auf unser Jahresabonnement.",
  anniversaryPaywallSubtitle: (years: number, discount: number) =>
    `Herzlichen Glückwunsch zu ${years} Jahren mit uns! Zur Feier gibt es einen ${discount}% Rabatt auf Premium. Danke für deine Treue!`,
  blackFridayAnnualTitle: "Dein Black Friday-Angebot 🎉",
  anniversaryAnnualTitle: "Dein Jubiläumsangebot 🎉",
  oneYear: "1 Jahr",
  oneMonth: "1 Monat",
  lockedIn: "Dieser Jahrespreis wird FÜR IMMER festgeschrieben sein",
  subtitleFixed: "Beeil dich, dieses Angebot endet bald!",
  importTitle: "Starte deinen Tresor",
  importSubtitle: "Es ist 100% privat!",
  importInfo:
    "Füge Fotos und Videos hinzu, die du versteckt und sicher aufbewahren möchtest.",
  importCTA: "Zum Tresor hinzufügen",
  skip: "Überspringen",
  totalMonthsPrice: (price: string) => `12 Monate • ${price}`,
  monthlyPrice: (price: string) => `${price} / Monat`,
  oneTimeOffer: {
    title: "Dein einmaliges Angebot",
    subTitle: "Sobald du dein einmaliges Angebot schließt, ist es weg!",
    claim: "Fordere dein einmaliges Angebot an",
  },
  returnOffer: {
    monthly: (price: string) => `ab nur ${price}/Monat`,
    title: "Ihr Exklusives Rückkehrangebot",
    subTitle:
      "Reaktivieren Sie Ihre Mitgliedschaft heute zu einem Sonderpreis! Nur für begrenzte Zeit verfügbar",
    discountTitle: "Spezialrabatt",
    cta: "Jetzt reaktivieren",
    discountSubTitle: "Angebot für begrenzte Zeit",
  },
  off: "RABATT",
  special: "SPEZIAL",
  yearlyPlan: "Jahresplan",
  monthlyPlan: "Monatsplan",
  subscribe: "Abonnieren",
  cancelAnytime: "Jederzeit kündbar",
  freeTrialPaywall: {
    title: "So funktioniert Ihre kostenlose Testversion",
    firstStep: {
      title: "Jetzt",
      subtitle:
        "Schalten Sie unbegrenzten Zugang zu Private Photo Vault frei und machen Sie sich nie wieder Sorgen darüber, dass jemand Ihre privaten Fotos sieht",
    },
    secondStep: {
      title: "Heute: Starten Sie Ihre kostenlose Testversion",
      subtitle:
        "Schalten Sie den vollen Zugang zu PhotoVault frei. Heute wird Ihnen nichts berechnet.",
    },
    thirdStep: {
      title: "In 7 Tagen",
      subtitle:
        "An diesem Tag wird Ihnen der Betrag berechnet. Jederzeit vorher kündbar, ganz ohne Aufwand.",
    },
    whatsIncluded: "Sehen Sie, was enthalten ist",
    viewAllPlans: "Alle Pläne anzeigen",
    startTrial: "Kostenlose Testversion starten",
    footerTitle: (yearlyPrice: string, monthlyPrice: string) =>
      `7 Tage KOSTENLOS und dann ${yearlyPrice}/Jahr\n(${monthlyPrice} pro Monat)`,
    footerDisclaimer:
      "Jederzeit vor Ende der Testversion kündbar. Sie werden erst nach 7 Tagen belastet.",
    featureList: {
      title: "Was ist Private Photo Vault?",
      infoTitle: "100% Privat und Sicher",
      infoSubtitle:
        "Schützen Sie Ihre Daten und verhindern Sie unbefugten Zugriff",
      subTitle: "Werden Sie Premium und erhalten Sie Zugang zu:",
    },
    comparePlans: {
      monthly: "Monatlich",
      yearly: "Jährlich",
      threeMonths: "3 Monate",
      ultimateYearly: "Ultimate jährlich",
      freeFor: (days: number) => `Kostenlos für ${days} Tage`,
      monthlyPrice: (price: string) => `nur ${price}/Monat`,
      dailyPrice: (price: string) => `nur ${price}/Tag`,
      cta: "Weiter",
    },
  },
  comparePlans: {
    title: "Pläne vergleichen",
    compare: "Vergleichen",
    freeTitle: "Kostenlos",
    basicTitle: "Basis",
    premiumTitle: "Premium",
    ultimateTitle: "Ultimate",
    unlockPremium: "Premium freischalten",
    unlockUltimate: "Ultimate freischalten",
    choose: "Wähle einen Plan",
  },
  features: {
    organizationPlus: "Organisation+",
    securityPlus: "Sicherheit+",
    duplicateDetection: "Doppelte Erkennung",
    faceDownLock: "Bildschirm-nach-unten-Sperre",
    customIcons: "Benutzerdefinierte Symbole",
    encryptedStorage: "Verschlüsselter Fotospeicher",
    unlimitedAlbums: "Unbegrenzte Alben",
    browser: "Sicherer Webbrowser",
    camera: "Private Kamera",
    subalbums: {
      title: "Unteralben",
      description:
        "Erstellen Sie mehrere Ebenen von Unteralben, um Ihren Inhalt effizient zu organisieren.",
    },
    filteringAndSearching: {
      title: "Filtern und Suchen",
      description:
        "Durchsuchen Sie Ihre Alben und wenden Sie Filter an, um bestimmte Inhaltstypen zu finden.",
    },
    alphanumericPasscode: {
      title: "Alphanumerisches Passwort",
      description:
        "Erhöhen Sie die Sicherheit Ihrer App, indem Sie ein alphanumerisches Passwort verwenden.",
    },
    dualLock: {
      title: "Passwort + Face ID erforderlich",
      description:
        "Für zusätzliche Sicherheit, verlangen Sie sowohl Passwort als auch Face ID jedes Mal, wenn Sie die App betreten.",
    },
    locationBasedLock: {
      title: "Standortbasierte Sperre",
      description:
        "Erlauben Sie das Entsperren der App nur an genehmigten GPS-Standorten.",
    },
  },
  gotIt: "Verstanden!",
  promo: {
    premiumSave: (percent: string) => `SPARE ${percent}% BEI PREMIUM`,
    monthly: (price: string) => `Nur ${price}/Monat`,
    yearly: (price: string) => `${price}/Jahr`,
    limited: "BEGRENZTE ZEIT VERFÜGBAR",
    claimOffer: "Angebot sichern",
    seconds: (count: number) => (count == 1 ? "SEKUNDE" : "SEKUNDEN"),
    minutes: (count: number) => (count == 1 ? "MINUTE" : "MINUTEN"),
    oneTimeOffer: "EINMALIGES ANGEBOT",
    normalFee: "normale Gebühr",
    backTo: "zurück zu",
    yearlyShort: (price: string) => `${price}/jährlich`,
  },
  premiumToUltimateBlackFriday: {
    title: "BLACK FRIDAY ANGEBOT",
    subTitle: "WERDEN SIE ULTIMATE",
    cloud: {
      title: "1.000 GB Cloud-Speicher",
      description: "Sicherer Cloud-Speicher für über 500.000 Fotos",
    },
    duplicateDetection: {
      description: "Doppelte Bilder finden und entfernen",
    },
    organizationPlus: {
      description:
        "Erstellen Sie Unteralben, filtern und durchsuchen Sie Ihre Fotos",
    },
    securityPlus: {
      description:
        "Erhöhte Sicherheit mit alphanumerischem Passcode, standortbasierter Sperre und mehr",
    },
    timeRemaining: "VERBLEIBENDE ZEIT",
    saleBanner: "MEGA SALE NUR FÜR KURZE ZEIT",
    saleTitle: "Black Friday Angebot 🎉",
    bannerTitle: (discount: number) => `${discount}% Rabatt zum Black Friday`,
    bannerCTA: "Angebot sichern",
    monthPrefix: "12 Mo • ",
    perMonthPrice(price: string) {
      return `${price} / Mo`
    },
    monthly: "Monatlich",
    ultimateLaunch: {
      title: "UPGRADE ZU Ultimate",
      saleTitle: "Ultimate Startangebot 🚀",
      bannerTitle: (discount) => `Ultimate Start - SPAREN SIE ${discount}%`,
    },
  },
  blackFridayNoFeatures: {
    title: "BLACK FRIDAY",
    lessThanCoffee: "Weniger als ein Kaffee.",
    dontWait: "Warte nicht! Dieses Angebot wird bald weg sein",
    whatWaiting: "Worauf wartest du?",
    claimOffer: "SICHERN SIE SICH IHR EINMALIGES ANGEBOT",
    moneyBack: "Geld-zurück-Garantie",
  },
  cyberMonday: {
    title: "CYBER MONDAY",
    subTitle: "HOLE DIR ULTIMATE",
    cloud: {
      title: "1.000 GB Cloud-Speicher",
      description: "Sicherer Cloud-Speicher für über 500.000 Fotos",
    },
    duplicateDetection: {
      description: "Duplikate finden und entfernen",
    },
    organizationPlus: {
      description: "Erstelle Unteralben, filtere und durchsuche deine Fotos",
    },
    securityPlus: {
      description:
        "Erhöhte Sicherheit mit alphanumerischem Passcode, standortbasierter Sperre und mehr",
    },
    timeRemaining: "VERBLEIBENDE ZEIT",
    saleBanner: "ZEITLICH BEGRENZTES CYBER-ANGEBOT",
    saleTitle: "Cyber Monday Angebot",
    bannerTitle: (discount: number) => `${discount}% RABATT am Cyber Monday`,
    bannerCTA: "Angebot sichern",
    monthPrefix: "12 Mo • ",
    perMonthPrice(price: string) {
      return `${price} / Mo`
    },
    monthly: "Monatlich",
    ultimateLaunch: {
      title: "UPGRADE ZU Ultimate",
      saleTitle: "Ultimate Startangebot",
      bannerTitle: (discount: number) =>
        `Upgrade zu Ultimate - SPARE ${discount}%`,
    },
  },
  beforeYouGo: {
    title: "Warte - Bevor du gehst",
    subtitle: "Halte deine Fotos sicher und privat",
    subtitle2: "Erhalte 7 Tage Premium völlig kostenlos.",
    cta: "Starte deine kostenlose Probezeit",
    cancelTitle:
      "Kündige jederzeit bevor deine Probezeit endet, und es fallen keine Kosten an, bis die vollen 7 Tage um sind.",
    skipCta: "Nein danke",
  },
  enableTrial: "Noch nicht sicher? Kostenlose Testversion aktivieren",
  startTrial: "Kostenlose Testversion starten",
  trialActivated: (days) => `${days}-TAGE-TESTVERSION AKTIVIERT`,
  specialOffer: {
    enabledTitle: "Sonderangebot aktiviert",
    trialTitle: "Sichere dir deine zusätzliche 7-tägige Testversion",
    expirationTitle: "Dein Abonnement läuft bald ab!",
    expirationSubtitle: "Verlängere jetzt zu einem Sonderpreis!",
    priceBoxExpiration: {
      title: "Sonderangebot zur Verlängerung",
      offerName: "Jahresplan",
      ctaTitle: "Sonderangebot sichern",
    },
    priceBoxTrial: {
      title: "Exklusives Angebot: 7 Tage zusätzlicher Testzeitraum",
      offerName: "Zusätzliche 7-Tage-Testversion",
      ctaTitle: "Zusätzliche Testversion sichern",
    },
  },
  premiumToUltimate: {
    titleLine1: "ULTIMATE-UPGRADE",
    titleLine2: "EINMALIGES ANGEBOT",
    megaSaleBanner: "ZEITLICH BEGRENZTER MEGA-SALE",
    upgradeTitle: "Ultimate-Upgrade-Angebot",
    yearlySubtitlePrefix: "12 Monate •",
    monthlyPriceSuffix: "/ Monat",
  },
  monthlyToYearly: {
    titleLine1: "Jährliches Upgrade",
    titleLine2: "Einmaliges Angebot",
    subtitleWarning: "Schließt du dieses Angebot, ist es weg!",
    specialLabel: "SPEZIAL",
    offerTitle: "Sichere dir dein einmaliges Angebot",
    offerName: "Jahresplan",
    subscribeButton: "Abonnieren",
    cancelAnytime: "Jederzeit kündbar",
    yearlySubtitlePrefix: "12 Monate •",
    monthlyPriceSuffix: "/ Monat",
  },
  expiration: {
    warmup: {
      close: "SCHLIESSEN",
      subtitle:
        "Halte deine Fotos SICHER und WIEDERHERSTELLBAR, falls dein Handy verloren geht oder gestohlen wird",
      features: {
        cloudVault: {
          title: "Cloud Vault",
          subtitle: "Verschlüsseltes Backup deiner Dateien",
        },
        cloudVaultUltimate: {
          title: "Cloud Vault",
          subtitle: "1.000 GB Cloud Vault-Speicher",
        },
        reviews: {
          title: "500.000+ 5-Sterne-Bewertungen",
          subtitle: "Vertraut von Millionen",
        },
        noAds: {
          title: "Keine Werbung",
          subtitle: "Werbefreie Nutzung",
        },
        organizationPlus: {
          title: "Organization+",
          subtitle: "Unteralben, bessere Filterung und mehr",
        },
      },
      footer: "& alle weiteren Funktionen!",
      switchToPremium: "Wechsle zu Premium",
      switchToUltimate: "Wechsle zu Ultimate",
      titlePremium: "Dein Premium ist abgelaufen!",
      titleUltimate: "Dein Ultimate ist abgelaufen!",
      popular: "BELIEBT",
      perMonth: "pro Monat",
      perYear: "pro Jahr",
    },
    titlePremium: "Premium ist abgelaufen",
    titleUltimate: "Ultimate ist abgelaufen",
    subtitlePremium:
      "Verlängere Premium, um alle Funktionen zu behalten, oder wechsle kostenlos zu Basic",
    subtitleUltimate:
      "Verlängere Ultimate, um alle Funktionen zu behalten, oder wechsle kostenlos zu Basic",
    basicButton: "Wechsle zu Basic",
    basicTitle: "Was ist Basic?",
    basicDescription:
      "Basic ist die kostenlose Version der App. Du kannst deine Fotos und Videos weiterhin mit einer PIN schützen. Du verlierst jedoch den Zugriff auf das verschlüsselte Cloud Vault-Backup und alle anderen Premium-Funktionen",
  },
  animated: {
    title: "Wähle deinen Plan",
    yearlyPrice: (price: string) => `Nur ${price} pro Jahr`,
    subtitle: "Automatisch verlängerbar. Jederzeit kündbar",
    cta: "Weiter",
    trial: "Kostenlose Testversion aktiviert",
    breakinShort: "Einbruchsbericht",
    unlimitedPhotos: "Unbegrenzte Fotos",
  },
  choosePlanTitle: "Wähle Deinen Plan",
  socialProof: {
    titleWithTrial: "Private Photo Vault testen\n7 Tage kostenlos",
    title: "Private Photo Vault testen",
    continueForFree: "Kostenlos fortfahren",
    continue: "Weiter",
    cancelAnytime: "Jederzeit kündbar",
    mostPopular: "Am beliebtesten",
    twelveMonths: "12 Monate",
    oneMonth: "1 Monat",
    yearlySubtitle: (monthlyPrice: string, yearlyPrice: string) =>
      `${monthlyPrice}/Monat, abgerechnet als ${yearlyPrice}/Jahr`,
    monthlySubtitle: (price: string) => `${price}/Monat`,
  },
  yearlyOnlyAppStore: {
    yearly: "Jährlich",
    billedYearly: (price: string) => `${price} jährlich abgerechnet`,
    perMonth: (price: string) => `${price}/Monat`,
    startTrial: (days: number) => `${days}-tägige Testphase starten`,
    purchaseWithAppStore: "Mit App Store kaufen  (ohne Testphase)",
    purchaseImmediately: "Sofort kaufen  (ohne Testphase)",
  },
  multistep: {
    lockTitle: "Private Fotos sperren",
    subtitle: {
      line1: "Wir bieten",
      line2: "7 Tage kostenlos",
      line3: "damit jeder seine Bilder schützen kann",
    },
    subtitleReminder: {
      line1: "Du erhältst eine Erinnerung ",
      line2: "2 Tage ",
      line3: "vor Ablauf deiner Testphase.",
    },
    noPaymentNow: "Jetzt keine Zahlung",
    startFreeWeek: "Starte deine GRATIS-Woche",
    payTitle: "7 Tage kostenlos",
    afterPrice: (price: string) => `danach ${price} / Monat`,
    afterBilling: (price: string) =>
      `(nach der Testphase jährlich mit ${price} abgerechnet)`,
    footerTitle: (price) => `7 Tage kostenlos. Danach ${price}/Jahr`,
    footerMonthlyTitle: (price) => `Es werden sofort ${price} berechnet.`,
    headerTitle: "7-tägige kostenlose Testversion",
    anual: "Jährlich",
    monthly: "Monatlich",
    noTrial: "Keine kostenlose Testversion",
    yearlyPrice: (price) => `${price} / Jahr`,
  },
  oneTimeOfferTitle: "EINMALIGES ANGEBOT",
  unlockPremiumFor: "Premium-Jahresabo freischalten für",
  oneTimeOfferSubtitle: "Dies ist ein einmaliges Angebot",
  lowestPrice: "NIEDRIGSTER PREIS ALLER ZEITEN",
  summerSale: {
    title: "SOMMERSCHLUSSVERKAUF",
    tagline: "Die Sonne sieht alles... außer was in deinem Tresor ist!",
    timeRemaining: "Angebot läuft bald ab",
    limitedTimeOffer: "Zeitlich begrenztes Angebot",
    savePercent: (percent: number) => `Spare ${percent}%`,
    bannerSubtitle: (price: string) => `Hol dir Premium für ${price}`,
    bannerSubtitleUltimate: (price: string) => `Hol dir Ultimate für ${price}`,
    getPremium: "Premium-Datenschutz erhalten",
    getUltimate: "Ultimate-Datenschutz erhalten",
    hours: "Stunden",
    minutes: "Minuten",
    seconds: "Sekunden",
    features: {
      premiumFeature: {
        title: "Erhalte alle Premium-Funktionen",
        description: "Premium-Tools, die deine Privatsphäre schützen.",
      },
      cloudVault: {
        title: "Cloud Vault - 50 GB",
        description: "Sichere Backups, die verschlüsselt bleiben.",
      },
      noAds: {
        title: "Keine Werbung",
        description: "Das volle Erlebnis ohne Unterbrechungen.",
      },
      faceDownLock: {
        title: "Face Down-Sperre",
        description: "App sofort sperren durch Umdrehen des Telefons.",
      },
      breakInReports: {
        title: "Einbruchsberichte",
        description: "Warnungen, wenn jemand auf deinen Tresor zugreifen will.",
      },
    },
    pricing: {
      summerSale: "Sommerschlussverkauf",
      monthly: "Monatlich",
      perMonth: (price: string) => `${price} / Mo`,
      twelveMonths: "12 Mo",
      originalPrice: (price: string) => price,
      discountedPrice: (price: string) => price,
    },
  },
  autumnSale: {
    title: "HERBST-SALE",
    tagline: "Blätter bedecken alles…\nauch deine Geheimnisse!",
    buttonTitle: "Herbst-Sale",
  },
  halloweenSale: {
    title: "HALLOWEEN-SALE",
    tagline: "Die Nacht verbirgt vieles…\nbesonders deine Geheimnisse!",
    buttonTitle: "Halloween-Sale",
  },
  winterSale: {
    title: "WINTER-SALE",
    tagline: "Schütze deine Fotos unter dem Schnee",
    buttonTitle: "Winter-Sale",
  },
  springSale: {
    title: "FRÜHLINGS-SALE",
    tagline: "Upgrade auf Premium mit diesem exklusiven Frühlingsrabatt",
    ultimateTagline:
      "Upgrade auf Ultimate mit diesem exklusiven Frühlingsrabatt",
    buttonTitle: "Frühlings-Sale",
  },
  emailPromo: {
    title: "Exklusives Premium-Angebot",
    upgradeButton: "Auf Premium upgraden",
    yearlyTitle: "Premium Jährlich",
    decoyDescription:
      "Erstellen Sie einen falschen Tresor, der sich mit einem Köder-Passwort öffnet",
  },
  tabsPaywall: {
    premiumTab: "Premium",
    ultimateTab: "Ultimate",
    premiumTitle: "Premium freischalten, um",
    premiumTitleHighlight: "Deinen Tresor zu sichern",
    ultimateTitleStart: "",
    ultimateTitleHighlight: "Ultimate",
    ultimateTitleEnd: " Freischalten\nFür Zugang zu Allen Funktionen",
    perMonth: "/Mo.",
  },
  trialFooter: {
    freeTrialDays: (days: number) => `${days} Tage\nkostenlos testen`,
    noFreeTrial: "Keine kostenlose\nTestversion",
    noCommitment: "Keine Bindung. Jederzeit kündbar.",
    cta: "Kostenlos testen",
    ctaMonthly: "Weiter",
    yearly: "Jährlich",
    monthly: "Monatlich",
  },
  onboardingUltimateAlternate: {
    title: "Starten Sie Ihre kostenlose Testversion",
    premiumDescription: "Schalten Sie hervorragende Datenschutztools frei.",
    ultimateDescription: "Das beste Photo Vault Erlebnis.",
    includesPremium: "Enthält Premium",
    trialPricing: (yearlyPrice: string, monthlyPrice: string) =>
      `7 Tage kostenlos, dann ${yearlyPrice} (${monthlyPrice}/Monat)`,
    timeline: {
      today: "Heute:",
      todayDescription: "starten Sie Ihre kostenlose Testversion",
      day5: "Tag 5:",
      day5Description: "Erinnerung erhalten",
      day7: "Tag 7:",
      day7Description: (yearlyPrice: string) =>
        `Ihnen werden ${yearlyPrice} berechnet`,
    },
    comparisonTable: {
      header: "Was Sie bekommen",
    },
    didYouKnow: {
      label: "Wussten Sie schon?",
      statNumber: "3X",
      statDescription: "Abonnenten erhalten 3-mal mehr Seelenfrieden",
    },
    pricing: {
      yearlyPlanTitle: "Jahresplan",
      yearlyPlanSubtitle: (yearlyPrice: string) => `${yearlyPrice}/Jahr`,
      yearlyAmount: (monthlyPrice: string) => `${monthlyPrice}/Monat`,
      monthlyTitle: "Monatlich",
      monthlyAmount: (monthlyPrice: string) => `${monthlyPrice}/Monat`,
      popularBadge: "BELIEBT",
    },
    ctaButton: "Kostenlose Testversion starten",
  },
  threeStepExpiration: {
    premiumExpired: "Dein Premium ist abgelaufen",
    ultimateExpired: "Ultimate-Abonnement ist abgelaufen",
    freeExpired: "Kostenloses Premium ist abgelaufen",
    subtitle: "Dein Konto wurde herabgestuft.",
    subtitlePremium: "Dein Konto wurde herabgestuft.",
    subtitleUltimate: "Dein Konto wurde herabgestuft.",
    allPremiumFeatures: "Alle Premium-Funktionen",
    allUltimateFeatures: "Alle Ultimate-Funktionen",
    spaceSaver: "Speicherplatzsparer",
    disabled: "Deaktiviert",
    restoreMyProtection: "Vollzugriff wiederherstellen",
    seeWhatImLosing: "Sehen, was ich verliere",
    photosSafeWarning:
      "Deine Fotos sind sicher, aber wichtige Funktionen sind jetzt deaktiviert.",
    continue: "Weiter",
    heresWhatYoureLosing: "Das verlierst du",
    allFeaturesDisabled:
      "Alle diese Premium-Funktionen werden in deinem Konto deaktiviert:",
    allFeaturesDisabledUltimate:
      "Alle diese Ultimate-Funktionen werden in deinem Konto deaktiviert:",
    back: "Zurück",
    stepOf: (current: number, total: number) =>
      `Schritt ${current} von ${total}`,
    restoreAllFeatures: "Alle Funktionen wiederherstellen",
    continueWithout: "Weiter (Funktionen bleiben deaktiviert)",
    allPremiumDetail:
      "Du verlierst den Zugang zu allen Premium-Funktionen, die deine privaten Fotos sicher und organisiert halten.",
    cloudVaultDetail:
      "Dein Cloud-Backup wird gelöscht. Wenn dein Gerät verloren geht oder beschädigt wird, sind deine privaten Fotos für immer weg.",
    cloudVaultDetailBold: "Dein Cloud-Backup wird gelöscht.",
    cloudVaultDetailRest:
      "Wenn dein Gerät verloren geht oder beschädigt wird, sind deine privaten Fotos für immer weg.",
    spaceSaverDetail:
      "Fotos belegen den vollen Speicherplatz auf deinem Gerät. Du kannst deinen Tresor nicht mehr komprimieren und optimieren.",
    trashDetail:
      "Versehentlich gelöschte Fotos können nicht wiederhergestellt werden. Einmal gelöscht, sind sie für immer weg.",
    noAdsDetail:
      "Du wirst in der gesamten App Werbung sehen. Premium entfernt alle Werbung für ein unterbrechungsfreies Erlebnis.",
    decoyDetail:
      "Dein Köder-Passcode funktioniert nicht mehr. Jeder, der davon weiß, könnte auf deinen echten Tresor zugreifen.",
    chooseYourPlan: "Wähle Deinen Plan",
    restoreFullProtection: "Vollen Schutz sofort wiederherstellen",
    restorePremiumInstantly: "Premium sofort wiederherstellen",
    restoreUltimateInstantly: "Ultimate sofort wiederherstellen",
    instantlyRestored: "Sofort wiederhergestellt",
    reassurance:
      "Mach genau dort weiter, wo du aufgehört hast — jede Funktion wird vollständig wiederhergestellt, sobald du abonnierst.",
    subscribeAndRestore: "Abonnieren & Wiederherstellen",
    scrollForMore: "Für mehr scrollen",
    bestValue: "BESTER WERT",
    switchToBasicDescription:
      "Du kannst weiterhin alle deine vorhandenen Fotos in der App ansehen und darauf zugreifen. Deine Alben und Medien bleiben sicher auf deinem Gerät.",
    viewAndAccess: "alle deine vorhandenen Fotos ansehen und darauf zugreifen",
    premiumFeaturesDisabled: "",
    restorePremium: "Premium wiederherstellen",
    restoreUltimate: "Ultimate wiederherstellen",
    choosePlanToReactivate:
      "Wähle einen Plan, um alle Funktionen zu reaktivieren",
    perMonth: "/Mo.",
    twelveMonths: "Jährlich",
    oneMonth: "1 Monat",
  },
  backupPaywall: {
    title: "Backups nicht aktiviert",
    subtitle:
      "Ihre Fotos und Videos werden nicht gesichert. Abonnieren Sie Premium, um Backups zu aktivieren und alle Funktionen freizuschalten",
    subscribe: "Premium holen",
    cancelAnytime: "Keine Verpflichtung. Jederzeit kündbar",
  },
  lossAversion: {
    title: "Kein einziges Foto wurde jemals\ngesichert.",
    subtitle:
      "Jedes Foto ist nur auf diesem Gerät gespeichert. Geht es verloren, sind sie für immer weg.",
    photosUnprotected: "Fotos\nungeschützt",
    backedUp: "gesichert",
    daysAtRisk: "Tage in Gefahr",
    backupCoverage: "Backup-Abdeckung",
    vaultProtected: (percent: number) =>
      `${percent}% deines Tresors sind geschützt`,
    premiumTitle: "Das bekommst du mit Premium",
  },
}
